import { render, staticRenderFns } from "./IntentExamples.vue?vue&type=template&id=5b1acdce&scoped=true&"
import script from "./IntentExamples.vue?vue&type=script&lang=js&"
export * from "./IntentExamples.vue?vue&type=script&lang=js&"
import style0 from "./IntentExamples.vue?vue&type=style&index=0&id=5b1acdce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1acdce",
  null
  
)

export default component.exports